@if (hrBannerVisible) {
  <rt-survey-banner
    [componentStorageKey]="'hr-survey-banner-2024'"
    [title]="'app.dashboard.hr_banner_2024.title' | translate"
    [description]="'app.dashboard.hr_banner_2024.description' | translate"
    [buttonText]="'app.dashboard.hr_banner_2024.button' | translate"
    [buttonTextSuffix]="'app.dashboard.hr_banner_2024.button_suffix' | translate"
    [link]="'app.dashboard.hr_banner_2024.link' | translate"
  ></rt-survey-banner>
}
